  $(document).ready(function(){
    $(".titleN").click(function(){
        var dataId = $(this).attr("data-id");
        $(".para").each(function(){	
        var id=$(this).attr("id");
        if(dataId == id){
          $(this).siblings('.titleN').toggleClass('iconss');
          $(this).slideToggle();
          // $(this).siblings('.titleN button span').css('transform','rotate(-45deg)');
        }else{
          $(this).siblings('.titleN').removeClass('iconss');
          $(this).slideUp();
        }
        });
    });
  });


 $(document).ready(function() {
    var $cartDrawer = $('#cart');
    // Open cart drawer on add to cart
    $(document).on('click', '.quick-view-bottom .barracuda-cart-addToCartButton', function(event) {
      // $cartDrawer.addClass('control-visible visible');
      setTimeout(() => {
        barracudaCart.refreshCart();
        openTopbar(event,'cart');
        // $('.barracuda-cart-opener.icon-cart').click();
      },2000);
    });
  });



document.addEventListener('DOMContentLoaded', function (){

  // ------------------------------------------ Variant change ------------------------------------------

  
    const addToCardBtn = document.querySelector('.barracuda-cart-addToCartButton');

    // Stay inside the button's own product form, so an open quick-view popup and the
    // product page behind it never read each other's swatches.
    const buyBoxScope = (addToCardBtn && addToCardBtn.closest('form')) || document;

    // Availability of every variant, keyed by variant id, from the hidden
    // .variant-data-source blocks rendered by snippets/product-form-source.liquid.
    function getVariantAvailability() {
      const availability = {};
      buyBoxScope.querySelectorAll('.variant-data-source').forEach((source) => {
        const flag = source.querySelector('[data-mapas="available"]');
        if (source.dataset.id && flag) {
          availability[source.dataset.id] = flag.innerText.trim() === 'true';
        }
      });
      return availability;
    }

    // The variant the shopper has actually selected: every checked swatch combined,
    // matched against the hidden variant select. Falls back to that select's own
    // value so single-option and single-variant products still resolve.
    function getSelectedVariantId() {
      const variantSelect = buyBoxScope.querySelector('.itgVariantSelect select');
      if (!variantSelect) return null;

      const checkedSwatches = buyBoxScope.querySelectorAll('.main_select_option:checked');
      if (checkedSwatches.length) {
        const title = Array.from(checkedSwatches).map((swatch) => swatch.value).join(' / ');
        const match = Array.from(variantSelect.options).find(
          (option) => option.innerText.trim() === title
        );
        if (match) return match.value;
      }
      return variantSelect.value;
    }

    // Sold out is a property of the SELECTED variant only - never of the product.
    // One sold-out variant must not disable the buy box for the others.
    function updateBuyBoxState() {
      if (!addToCardBtn) return;

      const variantId = getSelectedVariantId();
      const availability = getVariantAvailability();
      // Nothing to go on (e.g. a single-variant product): keep the server-rendered state.
      if (variantId === null || !(variantId in availability)) return;

      const dynamicButtons = buyBoxScope.querySelector('.dynamic-buy');
      if (availability[variantId]) {
        addToCardBtn.classList.remove('disabled');
        addToCardBtn.innerText = addToCardBtn.dataset.available || 'Add to cart';
        if (dynamicButtons) dynamicButtons.classList.remove('hidden');
      } else {
        addToCardBtn.classList.add('disabled');
        addToCardBtn.innerText = addToCardBtn.dataset.unavailable || 'Sold out';
        if (dynamicButtons) dynamicButtons.classList.add('hidden');
      }
    }

    // Set correct button state on page load based on the selected variant
    updateBuyBoxState();

    document.addEventListener('change', (e) => {
    let hiddenVariantSelect = document.querySelector('.itgVariantSelect select');
     if (e.target.closest('.main_select_option')) {
        const selectedValue = e.target.value;
        const subtitleText = e.target.dataset.substitle;
        const subtitleColor = e.target.dataset.subsbackcolor;
        const subsTitle = document.querySelector('.subscription_banner');
       let matchFound = false;
       let notBlank = false;

        // Buy box follows the newly selected variant, independently of the
        // subscription wrappers below (which only exist on selling-plan products).
        updateBuyBoxState();

        document.querySelectorAll('.Wrap_option').forEach((option) => {
          if (option.dataset.option === selectedValue) {
              matchFound = true;
              if (subtitleText) {
                notBlank = true;
              } 

            subsTitle?.classList.remove('hidden');
            option.classList.add('active');
             
            if (subsTitle && subtitleText) {
              subsTitle.innerText = subtitleText;
              subsTitle.style.backgroundColor = subtitleColor;
              subsTitle.style.minHeight = 'auto';
            }
          } else {
            option.classList.remove('active');
            subsTitle?.classList.add('hidden');
          }
        });

        if (matchFound) {
          subsTitle?.classList.remove('hidden');
        } else {
          subsTitle?.classList.add('hidden');
        }

        if (!notBlank && subsTitle) {
          subsTitle.innerText = '';
          subsTitle.style.minHeight = '20px';
        }

        let variantValue = '';
        let variants = document.querySelectorAll('.main_select_option:checked');
        let i = 1;
        variants.forEach((variant) => {
          if(variants.length == i){
            variantValue += variant.value;
          } else {
            variantValue += variant.value + ' / ';
          }
          i++;
        });
      
       let options = Array.from(hiddenVariantSelect.options);
        options.forEach((option) => {
          let optionValue = option.innerText.trim();
          console.log(optionValue, variantValue,optionValue == variantValue)
          if (optionValue == variantValue) {
            option.selected = true;
            ogPrice = option.dataset.ogprice;
            compPrice = option.dataset.compprice;
            const priceEl = document.querySelector('.product-price span.price.variant-data');
            if (priceEl) priceEl.innerText = ogPrice;
              const comparePriceEl = document.querySelector('.product-price span.price-before.variant-data');
            if (comparePriceEl) {
              if (compPrice && compPrice.trim() !== '') {
                comparePriceEl.innerText = compPrice;
                comparePriceEl.style.display = '';
                if (priceEl) priceEl.classList.add('price-on-sale', 'sale-price-color');
              } else {
                comparePriceEl.innerText = '';
                comparePriceEl.style.display = 'none';
                if (priceEl) priceEl.classList.remove('price-on-sale', 'sale-price-color');
              }
            }
            option.click();
            // Update ?variant= in the URL so third-party apps (e.g. KBite) can detect the selected variant
            if (history.replaceState) {
              var variantId = option.value;
              var separator = window.location.search.indexOf('variant=') !== -1 ? '' : (window.location.search ? '&' : '?');
              var newUrl = window.location.href.replace(/([?&])variant=\d+/, '$1variant=' + variantId);
              if (newUrl === window.location.href) newUrl = window.location.href.split('#')[0] + separator + 'variant=' + variantId;
              history.replaceState({ path: newUrl }, '', newUrl);
            }
            if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
              const productForm = document.querySelector("[bss-b2b-main-product-form]");
              BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
            }
          }
        });
      }
    });
  // ------------------------------------------------ Initial default-variant synchronisation
  // On first load Liquid pre-checks the resolved default size radio (e.g. 1 lb) and the product
  // form + main price already match it, but the delegated 'change' handler above never fired for
  // that default, and the Recharge subscription widget still shows the raw first option (8 oz).
  // Recharge only refreshes on a genuine variant transition, so we briefly select another size and
  // then re-select the default, driving the theme change handler each time. This is only needed
  // when the resolved default is NOT the first option (the value Recharge and Shopify default to),
  // which keeps excluded/first-default products (e.g. Puppy Gold, Go Dog) and single-variant
  // products untouched. Fully generic - no product-specific handles.
  function itgSelectSizeRadio(radios, radio) {
    radios.forEach(function (r) { r.checked = (r === radio); });
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function itgSyncDefaultVariant() {
    var radios = Array.prototype.slice.call(document.querySelectorAll('.main_select_option'));
    if (radios.length < 2) return; // single-variant product: nothing to reconcile
    var selected = radios.filter(function (r) { return r.checked; })[0] || radios[0];
    // Recharge/Shopify initialise to the first option; only reconcile when the default differs.
    if (selected === radios[0]) return;
    var bounce = radios[0];
    itgSelectSizeRadio(radios, bounce);
    setTimeout(function () { itgSelectSizeRadio(radios, selected); }, 350);
  }

  // Run after full load so Recharge (which initialises asynchronously) is ready to receive it.
  if (document.readyState === 'complete') {
    setTimeout(itgSyncDefaultVariant, 400);
  } else {
    window.addEventListener('load', function () { setTimeout(itgSyncDefaultVariant, 400); });
  }






 // ------------------------------------------ Save and Subscription option ------------------------------------------


   setTimeout(() => {
   function saveAndSub() {
      document.querySelectorAll('.purchase--option')?.forEach(option => {
        option.addEventListener('change', function() {
            let selectedPlan = document.querySelector('.Wrap_option.active  .purchase--option:checked').value;
            document.querySelector('#selling_plan_input').value = selectedPlan;
            if(document.querySelector('.product__subs__group.subscription_plane input.purchase--option:checked')){
              let selectedPlanBlock = document.querySelector('.Wrap_option.active .delivery_content select .block:checked').value;
              document.querySelector('#selling_plan_input').value = selectedPlanBlock;
           }
        });
      });
     
     
      document.querySelectorAll('.delivery_content select').forEach(select => {
          select?.addEventListener('change', function (){
           if(document.querySelector('.product__subs__group.subscription_plane input.purchase--option:checked')){
              let selectedPlanBlock = this.querySelector('.block:checked').value;
              document.querySelector('#selling_plan_input').value = selectedPlanBlock;
           }
        });
      })
   }
      function  purchaseClick() {
        document.querySelector('.Wrap_option.active .purchase--option')?.click();
      }
     setTimeout(() => {
      purchaseClick();
    },1000);
    
    document.addEventListener('click',(e) => {
      if(e.target.closest('.swatch-element')){
        setTimeout(() => {
          purchaseClick();
        },200);
      }
    });
    saveAndSub();
    document.addEventListener('click', (e) => {
      if(e.target.closest('.with-quick-view .icon-add-to-cart')){
        setTimeout(() => {
          saveAndSub();
          purchaseClick();
        },1000);
      }
    });
  },100);
  // ----------------------------------------------------------------------------------------------------------------
  // function saveAndSub() {
  //    document.querySelector('.purchase--option')?.click();
  //   document.querySelectorAll('.purchase--option')?.forEach(option => {
  //     option.addEventListener('change', function() {
  //         let selectedPlan = document.querySelector('.purchase--option:checked').value;
  //         document.getElementById('selling_plan_input').value = selectedPlan;
  //         if(document.querySelector('.product__subs__group.subscription_plane input.purchase--option:checked')){
  //           let selectedPlanBlock = document.querySelector('.deliver-select .block:checked').value;
  //           document.getElementById('selling_plan_input').value = selectedPlanBlock;
  //        }
  //     });
  //   });
  //   document.querySelector('.deliver-select')?.addEventListener('change', function (){
  //      if(document.querySelector('.product__subs__group.subscription_plane input.purchase--option:checked')){
  //         let selectedPlanBlock = this.querySelector('.block:checked').value;
  //         document.getElementById('selling_plan_input').value = selectedPlanBlock;
  //      }
  //   });
  // }
  // saveAndSub();
  // document.addEventListener('click', (e) => {
  //   if(e.target.closest('.with-quick-view .icon-add-to-cart')){
  //     setTimeout(() => {
  //       saveAndSub();
  //     },1000);
  //   }
  // });


  
 document.addEventListener('click', function(event) {
    const cartDrawer = document.querySelector('.main-cart.barracuda-cart-target');
    const controlVisible = document.querySelector('.control-visible');

    if (cartDrawer && !event.target.closest('.control-visible')) {
       // closeTopbar(event);
      document.querySelector('#cart .icon.icon-x').click();
    }
  });
});